import { deleteOfferFromFirebase } from "../../apiIntegration/deleteOfferFromFirebase";

export const autoDeleteExpiredOffers = (offers) => {
	const deletePromises = [];

	offers.forEach((offer) => {
		if (offer.expiresAt && Date.now() > offer.expiresAt) {
			deletePromises.push(
				deleteOfferFromFirebase({
					offerId: offer.offerId,
					shopId: offer.shopId,
					category: offer.category,
					subCategory: offer.subCategory,
					geoHash: offer.geoHash,
				}),
			);
		}
	});

	Promise.all(deletePromises).catch(console.error);
};
